import React from "react";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { Link } from "react-router-dom";


const DairyFarm = () => {
  const { dairyFarmMessage, loading, errors } = useTraceabilityData();

  // Extract message from context
  const message =
    dairyFarmMessage?.message ||
    dairyFarmMessage?.text ||
    dairyFarmMessage?.description ||
    "";
  const loadingState = loading.dairyFarm;
  const error = errors.dairyFarm || "";

  return (
    <div className="">
      {/* Page Heading */}
      <div className="wrapper2">
        <h2 className="heading2">Dairy Farm</h2>
      </div>

      {/* Dairy Farm Section */}
      <section className="py-0">
        <div className="container py-0">
          <div className="row g-3">
            <div className="col-lg-4 col-12">
              <a>
                <div className="product-item col">
                  <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                    <img
                      src="img/dairy-farm-bg.png"
                      alt=""
                      className="card-img-top"
                    />
                    <div className="position-absolute text-overlay text-white p-3">
                      <h1
                        className="fw-bold opacity-50"
                        style={{ fontSize: "4rem" }}
                      >
                        01
                      </h1>
                    </div>
                  </div>
                </div>
              </a>
              <p className="card-text text-muted py-3 px-2">
                {loadingState && "Loading dairy farm message..."}
                {!loadingState && error && <span>{error}</span>}
                {!loadingState && !error && message && <span>{message}</span>}
                {!loadingState && !error && !message && (
                  <span>No message available for this batch.</span>
                )}
              </p>
              <div className="underline2"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Dairy Farm Insights Section */}
      <div className="bg-light">
        <div className="container p-3">
          <h6 className="card-title fw-bold my-2">Dairy Farm Insights</h6>
          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-3 g-3">
            <Link to="/meet-our-cows">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box1.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Meet Our
                      <br /> Cattle
                    </h6>
                  </div>
                </div>
              </div>
            </Link>
            <Link to="/meet-the-farmers">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box2.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Meet Our Farmers
                    </h6>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/sustanibilty-in-dairy-farm">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box3.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Sustainability in Dairy Farms
                    </h6>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/open-housing-farm">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box4.png" alt="" className="card-img-top" />
                  <div
                    className="position-absolute text-overlay-f text-white p-3"
                    style={{ top: "30%" }}
                  >
                    <h6 className="fw-normal" style={{ fontSize: "12px" }}>
                      Learn About Open House Farming
                    </h6>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/farm-improvement-services">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box5.png" alt="" className="card-img-top" />
                  <div
                    className="position-absolute text-overlay-f text-white p-3"
                    style={{ top: "30%" }}
                  >
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Farm Improvement Services
                    </h6>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/smart-farming">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img
                    src="img/f-box6.png"
                    alt="Smart Farming"
                    className="card-img-top"
                  />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Smart Farming
                    </h6>
                  </div>
                </div>
              </div>
            </Link>

            {/* Repeat other insights items as in HTML */}
          </div>
        </div>
      </div>

      {/* Previous / Next buttons below grid */}
      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/home"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/meet-our-cows"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Next
        </Link>

      </div>
    </div>
  );
};

export default DairyFarm;
